import * as React from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Box, Typography, Card, Grid } from "@mui/material";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";

import { tl } from "../../../components/translate";
import EVENT from "../../../mixpanel-analytics/event";
import mixpanelAnalytics from "../../../mixpanel-analytics/mixpanelAnalytics";
import useCurrentResourceCentre from "../../../hooks/useCurrentResourceCentre";

// @ts-expect-error - css
import styles from "../Reports.module.css";
import { reportCardStyle, reportsCardContainerStyle } from "../ReportTypesList";

const AttendanceReports = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const rc = useCurrentResourceCentre();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ ...reportsCardContainerStyle }}>
        <Card
          sx={{ ...reportCardStyle }}
          onClick={() => {
            mixpanelAnalytics.track(EVENT.REPORT_GO_TO_ATTENDANCE_REPORT, {
              rcId: rc.id,
              rcName: rc.name
            });
            return dispatch(push("/reports/attendance/attendanceSummaryReport"));
          }}
          data-testmation="attendanceReportCard"
        >
          <Grid container>
            <Grid size={8}>
              <Box height="100%" width="100%">
                <Typography>
                  <Box component="span" fontWeight="700" fontSize="24px">
                    {tl("reports.attendanceSummaryReport")}
                  </Box>
                </Typography>
              </Box>
            </Grid>
            <Grid size={4}>
              <ChromeReaderModeIcon className={styles.reportCardChartIcon} />
            </Grid>
          </Grid>
        </Card>
      </Box>
    </Box>
  );
};

export default AttendanceReports;
